import { render, staticRenderFns } from "./UniverskinSerumPIcon.vue?vue&type=template&id=f54bc3ce"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports